import { render, staticRenderFns } from "./BillingBatchCard.vue?vue&type=template&id=10fdd278&scoped=true"
import script from "./BillingBatchCard.vue?vue&type=script&lang=js"
export * from "./BillingBatchCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fdd278",
  null
  
)

export default component.exports